import { defineComponent as X, useAttrs as Y, ref as r, useSlots as L, watch as P, onMounted as H, onUnmounted as M, computed as q, openBlock as c, createElementBlock as g, normalizeClass as x, unref as d, renderSlot as k, createBlock as D, mergeProps as R, createVNode as $, createElementVNode as B, normalizeStyle as G, toDisplayString as b, Fragment as I, createTextVNode as U } from "vue";
import { TooltipPlacement as i, TooltipVariant as j } from "./novoui-vuejs66.js";
import J from "./novoui-vuejs2.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import z from "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
const K = {
  key: 0,
  class: "tooltip-content-slot"
}, Ve = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "NTooltip",
  props: {
    variant: { default: "default" },
    placement: { default: void 0 },
    indicator: { type: Boolean, default: !0 },
    content: { default: void 0 },
    clickToggle: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    show: { type: Boolean, default: !1 },
    iconSize: { default: "normal" },
    preventWindowClipping: { type: Boolean, default: !1 }
  },
  emits: ["update:toggle", "update:close"],
  setup(S, { emit: E }) {
    const { class: N, ...C } = Y(), o = S, s = r(o.show), f = r(), m = r(), l = r(o.placement), n = r(), v = r(0), h = r(0), p = r({}), T = E;
    L(), P(
      () => o.show,
      (e, t) => {
        s.value = e, o.fixed && l.value && o.clickToggle && u(m.value.buttonRef), o.fixed && l.value && !o.clickToggle && u(f.value);
      }
    ), H(() => {
      o.preventWindowClipping && (window.addEventListener("resize", y), n.value.style.transform = "scale(1,1)", v.value = n.value.getBoundingClientRect().height + 8, h.value = n.value.getBoundingClientRect().width + 8, n.value.style.transform = "");
    }), M(() => {
      o.preventWindowClipping && window.removeEventListener("resize", y);
    });
    function y(e) {
      const t = e.target;
      switch (l.value) {
        case "down":
          t.innerHeight < n.value.getBoundingClientRect().y + v.value && t.innerHeight > n.value.getBoundingClientRect().y * 2 && (l.value = "up");
          break;
        case "right":
          t.innerWidth < n.value.getBoundingClientRect().x + h.value && t.innerWidth > n.value.getBoundingClientRect().x * 2 && (l.value = "left");
          break;
        case "left":
          (n.value.getBoundingClientRect().x - h.value < 0 && !s.value || n.value.getBoundingClientRect().x < 0) && (l.value = "right");
          break;
        case "up":
          (n.value.getBoundingClientRect().y - v.value < 0 && !s.value || n.value.getBoundingClientRect().y < 0) && (l.value = "down");
          break;
      }
    }
    function w(e, t) {
      if (s.value = e ? !1 : !s.value, T(e ? "update:close" : "update:toggle", t), !o.fixed || !l.value) {
        p.value = {};
        return;
      }
      u(m.value.buttonRef);
    }
    function u(e) {
      let t;
      if (!o.fixed || !l.value) {
        p.value = {};
        return;
      }
      e.buttonRef ? t = e.buttonRef : t = e, p.value = {
        transform: W(),
        top: F(t.getBoundingClientRect().y, t.getBoundingClientRect().height),
        left: V(t.getBoundingClientRect().x, t.getBoundingClientRect().width),
        bottom: "unset",
        right: "unset"
      };
    }
    const F = (e, t) => {
      switch (l.value) {
        case i.up:
          return `${e}px`;
        case i.right:
          return `${e + t / 2}px`;
        case i.left:
          return `${e + t / 2}px`;
        case i.down:
          return `${e + t}px`;
      }
    }, V = (e, t) => {
      switch (l.value) {
        case i.up:
          return `${e + t / 2}px`;
        case i.right:
          return `${e + t}px`;
        case i.left:
          return `${e}px`;
        case i.down:
          return `${e + t / 2}px`;
      }
    }, W = () => {
      const e = "16px";
      switch (l.value) {
        case i.up:
          return `translate(-50%, calc(-100% - ${e})) scaleX(1) scaleY(1)`;
        case i.right:
          return `translate(${e}, -50%) scaleX(1) scaleY(1)`;
        case i.left:
          return `translate(calc(-100% - ${e}), -50%) scaleX(1) scaleY(1)`;
        case i.down:
          return `translate(-50%, ${e}) scaleX(1) scaleY(1)`;
      }
    }, A = q(() => {
      if (!l.value)
        return "";
      switch (l.value) {
        case i.up:
          return "tooltip-up";
        case i.down:
          return "tooltip-down";
        case i.left:
          return "tooltip-left";
        case i.right:
          return "tooltip-right";
      }
    });
    return (e, t) => (c(), g("span", {
      class: x(["tooltip-container", d(N)])
    }, [
      k(e.$slots, "trigger", {
        ref: e.clickToggle ? "clickTrigger" : "hoverTrigger",
        triggerClick: (a) => w(!1, a),
        triggerHover: (a) => u(a),
        triggerClass: { "tooltip-hover-trigger": !o.clickToggle, "tooltip-button-trigger": o.clickToggle }
      }, () => [
        e.clickToggle ? (c(), D(J, R({ key: 0 }, C, {
          ref_key: "clickTrigger",
          ref: m,
          icon: "information",
          class: "tooltip-button-trigger",
          square: "",
          onClick: t[0] || (t[0] = (a) => w(!1, a))
        }), null, 16)) : (c(), g("button", R({ key: 1 }, C, {
          ref_key: "hoverTrigger",
          ref: f,
          class: "tooltip-hover-trigger",
          onMouseover: t[1] || (t[1] = () => u(f.value))
        }), [
          $(d(z), {
            icon: "information",
            class: "tooltip-icon-trigger",
            size: e.iconSize
          }, null, 8, ["size"])
        ], 16))
      ]),
      B("span", {
        class: x(["tooltip", [
          A.value,
          {
            shown: s.value,
            "tooltip-indicator": o.indicator,
            "tooltip-fixed": o.fixed,
            "tooltip-light": o.variant === d(j).light
          }
        ]]),
        ref_key: "tooltipElement",
        ref: n,
        style: G(p.value)
      }, [
        o.clickToggle ? (c(), g("div", K, [
          B("div", null, b(e.content), 1),
          B("button", {
            onClick: t[2] || (t[2] = (a) => w(!0, a)),
            class: "tooltip-close-button"
          }, [
            $(d(z), {
              icon: "closeSmall",
              size: "small"
            })
          ]),
          k(e.$slots, "default")
        ])) : (c(), g(I, { key: 1 }, [
          U(b(e.content) + " ", 1),
          k(e.$slots, "default")
        ], 64))
      ], 6)
    ], 2));
  }
});
export {
  Ve as default
};
